import ShareableLinkFileDownloadProvider from './ShareableLinkFileDownload.provider';

export default ShareableLinkFileDownloadProvider;